import { css, useTheme } from '@emotion/react';
import React, { memo } from 'react';
import { globals } from '../../../../utils/globals';
import { handleDLClickEvent } from '../../../../data-layer/handleDLClickEvent';
import { Link } from '../../../Link/Link';

const LogoSize = {
  law: {
    desktop: {
      width: 189,
      height: 38,
    },
    mobile: {
      width: 104,
      height: 22,
    },
  },
};

export const HeaderLogo = memo(({ isSticky = false, isDrawer = false }: any) => {
  const theme = useTheme();
  const wrapper = css`
    ${theme.widgets.GlobalHeader?.headerLogo}
  `;
  const media = theme.breakpoints.lg ? theme.breakpoints.lg.replace('@media', '') : '';

  // Determine which logo variant to use
  let desktopImage = theme.assets.headerLogoImgUrl;
  let mobileImage = theme.assets.headerLogoMobileImgUrl;

  if (isSticky) {
    desktopImage = theme.assets.stickyHeaderLogoImgUrl;
    mobileImage = theme.assets.stickyHeaderLogoImgUrl;
  } else if (isDrawer) {
    desktopImage = (theme.assets as any).drawerHeaderLogoImgUrl || theme.assets.headerLogoImgUrl;
    mobileImage = (theme.assets as any).drawerHeaderLogoMobileImgUrl || theme.assets.headerLogoMobileImgUrl;
  }

  const { width: desktopWidth, height: desktopHeight } =
    LogoSize[globals.brandId as keyof typeof LogoSize]?.desktop || {};
  const { width: mobileWidth, height: mobileHeight } = LogoSize[globals.brandId as keyof typeof LogoSize]?.mobile || {};

  return (
    <div data-test="widget-HeaderLogo" css={wrapper} id="header-logo">
      {/* Using Anchor tag instead of Link Component because when clicking on Logo, App will be redirected to the ATG Homepage. 
      In the future when Home page is migrated fully to NextJS app, Link Component can be used */}
      <Link
        href="/"
        data-event="headerLogoClick"
        data-section="header:logo"
        data-action="logo"
        data-name="header logo"
        data-text="logo"
        onClick={() => {
          handleDLClickEvent(globals.brandId as string, 'topNavClick');
        }}
      >
        <picture>
          <source media={media} srcSet={desktopImage} width={desktopWidth} height={desktopHeight} />
          <img
            src={mobileImage}
            alt="Logo"
            className={isDrawer ? 'drawer-header-logo-img' : undefined}
            fetchPriority={isSticky ? 'low' : 'high'}
            loading={isSticky ? 'lazy' : 'eager'}
            width={mobileWidth}
            height={mobileHeight}
          />
        </picture>
      </Link>
    </div>
  );
});
